
import PlansDesktop from "./plans-desktop.vue";
import PlansMobile from "./plans-mobile.vue";

export default {
  props: ["mobile"],
  data() {
    return {
      CdnData: null,
    };
  },
  async fetch() {
    try {
      const response = await this.$axios.$get("api/v1/cdn/plans-overview");
      this.CdnData = response.data;
    } catch (error) {
      console.error("Error fetching data in fetch:", error);
    }
  },
  mounted() {
    if (!this.CdnData) {
      this.getPlans();
    }
  },
  methods: {
    async getPlans() {
      try {
        const response = await this.$axios.$get("api/v1/cdn/plans-overview");
        this.CdnData = response.data;
      } catch (error) {
        console.error("Failed to fetch CDN plans:", error);
      }
    },
  },
  components: { PlansDesktop, PlansMobile },
};
